import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-rating-3",
  "use": "foquz-icon-rating-3-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol viewBox=\"0 0 22 22\" fill=\"none\" id=\"foquz-icon-rating-3\"><path d=\"M22 11c0 6.075-4.925 11-11 11S0 17.075 0 11 4.925 0 11 0s11 4.925 11 11z\" fill=\"#F4A224\" /><rect x=\"7\" y=\"14\" width=\"8\" height=\"2\" rx=\"1\" fill=\"#fff\" /><circle cx=\"7.5\" cy=\"8.5\" r=\"1.5\" fill=\"#fff\" /><circle cx=\"14.5\" cy=\"8.5\" r=\"1.5\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol